import moment from 'moment';
import { GetCurrencySymbol } from '../../../../core/utils/GetCurrenciesData';
import {
	COMMISSIONS_SUMMARY_VIEW,
	COMMISSIONS_DETAILED_VIEW,
	COMMISSIONS_NONE_VIEW
} from '../../../../core/utils/Constants/Constants';
import { GenerateEmptyMonthStatements } from '../../../../core/utils/GenerateEmptyMonthStatements';
import { GetMonths } from '../../../../core/utils/GetMonths';
import { GenerateMonthStatements, GenerateReferralsMonthStatements } from '../../../../core/utils/GenerateMonthStatements';
import { FilterMonthStatements } from '../../../../core/utils/FilterMonthStatements';
import { getReferralsViewTypeFromCommissionsViewType } from '../../../../core/utils/GetReferralsViewType';
import { MonthDropdownData, MonthStatementDataType, SummaryDetails } from '../../../../core/types/GenrateMonthStatements';
import { MonthsObject } from '../../../../core/utils/GetMonths/GetMonths';
import { AscendingSort } from '../../../../core/utils/Formatter/AscendingSort';
import { Series } from '../../../../core/types/Series';

type EntryType = {
	calendaryear: number;
	numberofregistrations: number;
	numberofreferrals: number;
	calendarmonth: number;
	numberoftradedaccounts: number;
}

type MonthWiseFieldsArrayType = {
    fieldName: string;
    fieldLabel: string;
    fieldType: string;
    fieldValue?: string | number;
}[];

const generateMonthsData = (months: MonthsObject, entry: EntryType, translate: Function) => {
	const today: moment.Moment = moment();
	today.date(1);
	const currentYear: string = today.format('YYYY');
	const date: moment.Moment = moment();

	date.date(1);
	date.month(entry.calendarmonth - 1);
	date.year(entry.calendaryear);

	const month: string = date.format('MMM');
	const formattedPeriod: string = month.charAt(0).toUpperCase()+ month.slice(1);
	const year: string = date.format('YYYY');
	const monthWiseFieldsArray: MonthWiseFieldsArrayType = months[formattedPeriod].fields;

	if (months[formattedPeriod]) {
		if (currentYear === year && entry.calendarmonth - 1 > today.month()) {
			monthWiseFieldsArray.push({
				fieldName: translate('referrals.chart.legend.referrals.label')?.toLowerCase(),
				fieldLabel: translate('referrals.chart.legend.referrals.label'),
				fieldType: 'number'
			});

			monthWiseFieldsArray.push({
				fieldName: translate('referrals.chart.legend.registrations.label')?.toLowerCase(),
				fieldLabel: translate('referrals.chart.legend.registrations.label'),
				fieldType: 'number'
			});

			monthWiseFieldsArray.push({
				fieldName: translate('referrals.chart.legend.traded.accounts.inner.label')?.toLowerCase(),
				fieldLabel: translate('referrals.chart.legend.traded.accounts.label'),
				fieldType: 'number'
			});
		} else {
			monthWiseFieldsArray.push({
				fieldName: translate('referrals.chart.legend.referrals.label')?.toLowerCase(),
				fieldLabel: translate('referrals.chart.legend.referrals.label'),
				fieldValue: entry.numberofreferrals,
				fieldType: 'number'
			});

			monthWiseFieldsArray.push({
				fieldName: translate('referrals.chart.legend.registrations.label')?.toLowerCase(),
				fieldLabel: translate('referrals.chart.legend.registrations.label'),
				fieldValue: entry.numberofregistrations,
				fieldType: 'number'
			});

			monthWiseFieldsArray.push({
				fieldName: translate('referrals.chart.legend.traded.accounts.inner.label')?.toLowerCase(),
				fieldLabel: translate('referrals.chart.legend.traded.accounts.label'),
				fieldValue: entry.numberoftradedaccounts,
				fieldType: 'number'
			});
		}
	}
}

export const convert = (summary: SummaryDetails, translate: Function) => {
	let monthStatements: MonthStatementDataType[] = GenerateMonthStatements(summary);
	let series: Array<Series> | [] = [];

	if (summary.referral_graph_details) {
		const months: MonthsObject = GetMonths();

		if (!(summary?.referral_graph_details && summary.referral_graph_details.length > 0)) {
			let referralGraphDetailsObj = {
				numberofregistrations: 0,
				numberofreferrals: 0,
				numberoftradedaccounts: 0
			};
			summary.referral_graph_details = GenerateEmptyMonthStatements(monthStatements, referralGraphDetailsObj);
		}
		monthStatements = FilterMonthStatements(monthStatements, summary);
		summary.referral_graph_details.length && summary.referral_graph_details.forEach((entry: EntryType) => {
			generateMonthsData(months, entry, translate);
		});
		series = AscendingSort(months) as Array<Series>;
	}

	return {
		series,
		statements: monthStatements.reverse(),
		summaries: {
			referrals: summary.referral_info_details[0].yourreferrals,
			registrations: summary.referral_info_details[0].registrations,
			accounts: summary.referral_info_details[0].tradedaccounts
		}
	};
}

export const getMonthStatement = (dropdownData: MonthDropdownData) => {
	const monthData = dropdownData.calendar_year_month_dropdown || [];
	const monthStatements: MonthStatementDataType[] = GenerateReferralsMonthStatements(monthData);
	return monthStatements;
}

export const details = (transactions: any, referralsViewType: string, commissionViewType: string, translate: Function) => {
	const events: any = [];
	referralsViewType === COMMISSIONS_SUMMARY_VIEW && transactions.referral_registration_trade_summary.forEach((transaction: any) => {
		if (!transaction["@metadata"]) {
			const transaction_date = moment(transaction.date);

			const entry: any = {
				event: {
					tier: transaction.tab,
					eventType: transaction.tab.toLowerCase(),
					eventLabel: transaction_date.format('DD/MM/YYYY')
				},
				fields: []
			};

			switch (transaction.tab) {
				case 'Referral':
					entry.fields.push({
						fieldName: 'customer_name',
						fieldLabel: translate('referrals.tab.column.client.name'),
						fieldValue: transaction.customername,
						fieldType: 'string'
					});

					entry.fields.push({
						fieldName: 'type',
						fieldLabel: translate('referrals.tab.column.type'),
						fieldValue: transaction.type,
						fieldType: 'string'
					});

					entry.fields.push({
						fieldName: 'date',
						fieldLabel: translate('referrals.tab.column.date'),
						fieldValue: transaction_date.format('DD/MM/YYYY'),
						fieldType: 'string'
					});

					break;
				case 'Registration':
					entry.fields.push({
						fieldName: 'customer_name',
						fieldLabel: translate('referrals.tab.column.client.name'),
						fieldValue: transaction.customername,
						fieldType: 'string'
					});

					entry.fields.push({
						fieldName: 'status',
						fieldLabel: translate('referrals.tab.column.type'),
						fieldValue: transaction.type,
						fieldType: 'string'
					});

					entry.fields.push({
						fieldName: 'date',
						fieldLabel: translate('referrals.tab.column.date.registered'),
						fieldValue: transaction_date.format('DD/MM/YYYY'),
						fieldType: 'string'
					});

					break;
				case 'Trades':
					entry.fields.push({
						fieldName: 'customer_name',
						fieldLabel: translate('referrals.tab.column.client.name'),
						fieldValue: transaction.customername,
						fieldType: 'string'
					});

					entry.fields.push({
						fieldName: 'type',
						fieldLabel:  translate('referrals.tab.column.type'),
						fieldValue: transaction.type,
						fieldType: 'string'
					});

					if (commissionViewType === COMMISSIONS_SUMMARY_VIEW) {
						entry.fields.push({
							fieldName: 'commission',
							fieldLabel: translate('referrals.tab.column.commission'),
							fieldValue: transaction.commissionamount,
							fieldType: 'currency',
							customAttributes: {
								currency: GetCurrencySymbol(transaction.commissionamountcurrency)
							}
						});
					}

					entry.fields.push({
						fieldName: 'date',
						fieldLabel: translate('referrals.tab.column.closed.date'),
						fieldValue: transaction_date.format('DD/MM/YYYY'),
						fieldType: 'string'
					});

					break;
			}

			events.push(entry);
		}
	});

	referralsViewType === COMMISSIONS_DETAILED_VIEW && transactions.referral_registration_trade_detailed.forEach((transaction: any) => {
		if (!transaction["@metadata"]) {
			const transaction_date = moment(transaction.date);

			const entry: any = {
				event: {
					tier: transaction.tab,
					eventType: transaction.tab.toLowerCase(),
					eventLabel: transaction_date.format('DD/MM/YYYY')
				},
				fields: []
			};

			switch (transaction.tab) {
				case 'Referral':
					entry.fields.push({
						fieldName: 'uid',
						fieldLabel: 'UID',
						fieldValue: transaction.uid,
						fieldType: 'string'
					});

					entry.fields.push({
						fieldName: 'type',
						fieldLabel: translate('referrals.tab.column.type'),
						fieldValue: transaction.type,
						fieldType: 'string'
					});

					entry.fields.push({
						fieldName: 'date',
						fieldLabel: translate('referrals.tab.column.date'),
						fieldValue: transaction_date.format('DD/MM/YYYY'),
						fieldType: 'string'
					});
					break;

				case 'Registration':
					entry.fields.push({
						fieldName: 'customer_id',
						fieldLabel:  translate('referrals.tab.column.client.id'),
						fieldValue: transaction.customerid,
						fieldType: 'string'
					});

					entry.fields.push({
						fieldName: 'uid',
						fieldLabel: 'UID',
						fieldValue: transaction.uid,
						fieldType: 'string'
					});

					entry.fields.push({
						fieldName: 'type',
						fieldLabel: translate('referrals.tab.column.type'),
						fieldValue: transaction.type,
						fieldType: 'string'
					});

					entry.fields.push({
						fieldName: 'date',
						fieldLabel: translate('referrals.tab.column.date.registered'),
						fieldValue: transaction_date.format('DD/MM/YYYY'),
						fieldType: 'string'
					});

					break;

				case 'Trades':
					entry.fields.push({
						fieldName: 'customer_id',
						fieldLabel: translate('referrals.tab.column.client.id'),
						fieldValue: transaction.customerid,
						fieldType: 'string'
					});

					entry.fields.push({
						fieldName: 'uid',
						fieldLabel: 'UID',
						fieldValue: transaction.uid,
						fieldType: 'string'
					});

					entry.fields.push({
						fieldName: 'type',
						fieldLabel: translate('referrals.tab.column.type'),
						fieldValue: transaction.type,
						fieldType: 'string'
					});

					entry.fields.push({
						fieldName: 'sold',
						fieldLabel: translate('referrals.tab.column.sold'),
						fieldValue: transaction.sold,
						fieldType: 'string'
					});

					entry.fields.push({
						fieldName: 'bought',
						fieldLabel: translate('referrals.tab.column.bought'),
						fieldValue: transaction.bought,
						fieldType: 'string'
					});

					entry.fields.push({
						fieldName: 'turnover',
						fieldLabel: translate('referrals.tab.column.turnover'),
						fieldValue: transaction.turnover,
						fieldType: 'currency'
					});

					if (commissionViewType === COMMISSIONS_DETAILED_VIEW) {
						entry.fields.push({
							fieldName: 'profit',
							fieldLabel: translate('referrals.tab.column.profit'),
							fieldValue: transaction.revenue,
							fieldType: 'currency',
							customAttributes: {
								currency: GetCurrencySymbol(transaction.revenuecurrency)
							}
						});

						entry.fields.push({
							fieldName: 'commission',
							fieldLabel: translate('referrals.tab.column.commission'),
							fieldValue: transaction.commissionamount,
							fieldType: 'currency',
							customAttributes: {
								currency: GetCurrencySymbol(transaction.commissionamountcurrency)
							}
						});
					}

					entry.fields.push({
						fieldName: 'closed_date',
						fieldLabel: translate('referrals.tab.column.closed.date'),
						fieldValue: transaction_date.format('DD/MM/YYYY'),
						fieldType: 'string'
					});

					break;
			}

			events.push(entry);
		}
	});

	return {
		events
	}
};

const TradeData = (transactions: any, viewType: string, translate: Function) => {
	const events: any = [];
	const isNoCommissionView: boolean = viewType === COMMISSIONS_NONE_VIEW;

	let referralsViewType: string = getReferralsViewTypeFromCommissionsViewType(viewType);

	referralsViewType === COMMISSIONS_SUMMARY_VIEW && transactions?.length > 0 && transactions.forEach((transaction: any) => {
		if (!transaction["@metadata"]) {
			const transaction_date = moment(transaction.date);
			const entry: any = {
				event: {
					eventLabel: transaction_date.format('DD/MM/YYYY')
				},
				fields: []
			};

			entry.fields.push({
				fieldName: 'type',
				fieldLabel: translate('referrals.tab.column.type'),
				fieldValue: transaction.type,
				fieldType: 'string'
			});


			!isNoCommissionView && entry.fields.push({
				fieldName: 'commissionamount',
				fieldLabel: translate('referrals.tab.column.commission'),
				fieldValue: transaction.commissionamount,
				fieldType: 'currency',
				customAttributes: {
					currency: GetCurrencySymbol(transaction.commissionamountcurrency)
				}
			});


			entry.fields.push({
				fieldName: 'date',
				fieldLabel: translate('referrals.tab.column.closed.date'),
				fieldValue: transaction_date.format('DD/MM/YYYY'),
				fieldType: 'string'
			});

			events.push(entry);
		}
	});

	referralsViewType === COMMISSIONS_DETAILED_VIEW && transactions?.length > 0 && transactions.forEach((transaction: any) => {
		if (!transaction["@metadata"]) {
			const transaction_date = moment(transaction.date);
			const entry: any = {
				event: {
					eventLabel: transaction_date.format('DD/MM/YYYY')
				},
				fields: []
			};

			entry.fields.push({
				fieldName: 'type',
				fieldLabel: translate('referrals.tab.column.type'),
				fieldValue: transaction.type,
				fieldType: 'string'
			});

			entry.fields.push({
				fieldName: 'sold',
				fieldLabel:  translate('referrals.tab.column.sold'),
				fieldValue: transaction.sold,
				fieldType: 'string'
			});

			entry.fields.push({
				fieldName: 'bought',
				fieldLabel: translate('referrals.tab.column.bought'),
				fieldValue: transaction.bought,
				fieldType: 'string'
			});

			entry.fields.push({
				fieldName: 'turnover',
				fieldLabel: translate('referrals.tab.column.turnover'),
				fieldValue: transaction.turnover,
				fieldType: 'currency'
			});

			if (!isNoCommissionView) {
				entry.fields.push({
					fieldName: 'commissionamount',
					fieldLabel: translate('referrals.tab.column.commission'),
					fieldValue: transaction.commissionamount,
					fieldType: 'currency',
					customAttributes: {
						currency: GetCurrencySymbol(transaction.commissionamountcurrency)
					}
				});

				entry.fields.push({
					fieldName: 'profit',
					fieldLabel: translate('referrals.tab.column.profit'),
					fieldValue: transaction.revenue,
					fieldType: 'currency',
					customAttributes: {
						currency: GetCurrencySymbol(transaction.revenuecurrency)
					}
				});
			}

			entry.fields.push({
				fieldName: 'date',
				fieldLabel: translate('referrals.tab.column.closed.date'),
				fieldValue: transaction_date.format('DD/MM/YYYY'),
				fieldType: 'string'
			});

			events.push(entry);
		}
	});
	return {
		events
	}
};

export const searchDetails = (transactions: any, searchValue: string, viewType: string, translate: Function) => {
	const events: any = [];

	let referralsViewType: string = getReferralsViewTypeFromCommissionsViewType(viewType);

	referralsViewType === COMMISSIONS_SUMMARY_VIEW && transactions?.search_results && transactions.search_results.forEach((transaction: any) => {
		if (!transaction["@metadata"]) {
			const referred_transaction_date = moment(transaction.referraldate);
			const registered_transaction_date = moment(transaction.registrationdate);

			const entry: any = {
				event: {
					eventLabel: referred_transaction_date.format('DD/MM/YYYY')
				},
				fields: []
			};

			entry.fields.push({
				fieldName: 'customer_name',
				fieldLabel: translate('referrals.tab.column.client.name'),
				fieldValue: transaction.clientname,
				fieldType: 'string'
			});

			entry.fields.push({
				fieldName: 'email',
				fieldLabel: translate('referrals.tab.column.email'),
				fieldValue: transaction.clientemail,
				fieldType: 'string'
			});

			entry.fields.push({
				fieldName: 'type',
				fieldLabel: translate('referrals.tab.column.type'),
				fieldValue: transaction.type,
				fieldType: 'string'
			});

			entry.fields.push({
				fieldName: 'referreddate',
				fieldLabel: translate('referrals.tab.column.referred'),
				fieldValue: referred_transaction_date.isValid() ? referred_transaction_date.format('DD/MM/YYYY') : '',
				fieldType: 'string'
			});

			entry.fields.push({
				fieldName: 'registereddate',
				fieldLabel: translate('referrals.tab.column.registered'),
				fieldValue: registered_transaction_date.isValid() ? registered_transaction_date.format('DD/MM/YYYY') : 'referrals.search.table.not.registered.label',
				fieldType: registered_transaction_date.isValid() ? 'string' : 'no-data'
			});

			entry.fields.push({
				fieldName: 'Trades',
				fieldLabel: '',
				fieldValue: transaction?.trades !== null && transaction?.trades?.length !== 0 ? 'Trades' : '',
				fieldArrayValue: transaction?.trades !== null && transaction?.trades?.length !== 0 ? TradeData(transaction.trades, viewType, translate) : [],
				fieldType: 'array'
			});

			events.push(entry);
		}
	});

	referralsViewType === COMMISSIONS_DETAILED_VIEW && transactions && transactions.search_results.forEach((transaction: any) => {
		if (!transaction["@metadata"]) {
			const referred_transaction_date = moment(transaction.referraldate);
			const registered_transaction_date = moment(transaction.registrationdate);

			const entry: any = {
				event: {
					eventLabel: referred_transaction_date.format('DD/MM/YYYY')
				},
				fields: []
			};

			entry.fields.push({
				fieldName: 'client_id',
				fieldLabel: translate('referrals.tab.column.client.id'),
				fieldValue: transaction.customerid,
				fieldType: 'string'
			});

			entry.fields.push({
				fieldName: 'uid',
				fieldLabel: 'UID',
				fieldValue: transaction.uid,
				fieldType: 'string'
			});

			entry.fields.push({
				fieldName: 'status',
				fieldLabel: translate('referrals.tab.column.type'),
				fieldValue: transaction.type,
				fieldType: 'string'
			});

			entry.fields.push({
				fieldName: 'referreddate',
				fieldLabel: translate('referrals.tab.column.referred'),
				fieldValue: referred_transaction_date.isValid() ? referred_transaction_date.format('DD/MM/YYYY') : '',
				fieldType: 'string'
			});

			entry.fields.push({
				fieldName: 'registereddate',
				fieldLabel: translate('referrals.tab.column.registered'),
				fieldValue: registered_transaction_date.isValid() ? registered_transaction_date.format('DD/MM/YYYY') : 'referrals.search.table.not.registered.label',
				fieldType: registered_transaction_date.isValid() ? 'string' : 'no-data'
			});

			entry.fields.push({
				fieldName: 'Trades',
				fieldLabel: '',
				fieldValue: transaction?.trades !== null && transaction?.trades?.length !== 0 ? 'Trades' : '',
				fieldArrayValue: transaction?.trades !== null && transaction?.trades?.length !== 0 ? TradeData(transaction.trades, referralsViewType, translate) : [],
				fieldType: 'array'
			});

			events.push(entry);
		}
	});

	return {
		events,
		searchValue,
		referralsViewType
	}
};